import React, { useState } from 'react';
import axios from 'axios';

const ArchanaiPage = ({ language }) => {
  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    gotram: '',
    nakshatram: '',
    rashi: '',
    deity: '',
    temple: '',
    date: '',
    time: 'morning',
    specialRequests: '',
    participantNames: '',
    paymentMethod: 'razorpay'
  });
  const [loading, setLoading] = useState(false);
  const API = process.env.REACT_APP_BACKEND_URL;

  const temples = [
    { value: 'ahobilam', label_en: 'Ahobilam Temple (Andhra Pradesh)', label_ta: 'அஹோபிலம் கோயில் (ஆந்திரப் பிரதேசம்)', price: 500 },
    { value: 'srirangam', label_en: 'Srirangam Temple (Tamil Nadu)', label_ta: 'ஸ்ரீரங்கம் கோயில் (தமிழ்நாடு)', price: 600 },
    { value: 'tirupati', label_en: 'Tirupati Temple (Andhra Pradesh)', label_ta: 'திருப்பதி கோயில் (ஆந்திரப் பிரதேசம்)', price: 1000 },
    { value: 'kanchipuram', label_en: 'Varadaraja Temple (Kanchipuram)', label_ta: 'வரதராஜ பெருமாள் கோயில் (காஞ்சிபுரம்)', price: 500 },
    { value: 'melkote', label_en: 'Melkote Cheluvanarayana Temple', label_ta: 'மேல்கோட்டை செளவனாராயண கோயில்', price: 400 }
  ];

  const deities = [
    { value: 'narasimha', label_en: 'Lord Narasimha', label_ta: 'நரசிம்மர்' },
    { value: 'vishnu', label_en: 'Lord Vishnu', label_ta: 'விஷ்ணு' },
    { value: 'lakshmi_narayana', label_en: 'Lakshmi Narayana', label_ta: 'லட்சுமி நாராயணன்' },
    { value: 'venkateshwara', label_en: 'Lord Venkateshwara', label_ta: 'வெங்கடேஸ்வரர்' },
    { value: 'ranganatha', label_en: 'Lord Ranganatha', label_ta: 'ரங்கநாதர்' }
  ];

  const timeSlots = [
    { value: 'morning', label_en: 'Morning Puja (6 AM - 9 AM)', label_ta: 'காலை பூஜை (6 AM - 9 AM)' },
    { value: 'afternoon', label_en: 'Afternoon Puja (12 PM - 3 PM)', label_ta: 'மதிய பூஜை (12 PM - 3 PM)' },
    { value: 'evening', label_en: 'Evening Puja (5 PM - 8 PM)', label_ta: 'மாலை பூஜை (5 PM - 8 PM)' }
  ];

  const getSelectedPrice = () => {
    const selected = temples.find(t => t.value === bookingData.temple);
    return selected ? selected.price : 0;
  };

  const handleBooking = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const amount = getSelectedPrice();
      
      if (bookingData.paymentMethod === 'razorpay') {
        const orderRes = await axios.post(`${API}/payments/razorpay/create-order`, {
          amount: amount,
          currency: 'INR',
          receipt: `archanai_${Date.now()}`,
          notes: { 
            service: 'archanai',
            customer: bookingData.name,
            temple: bookingData.temple,
            deity: bookingData.deity,
            date: bookingData.date
          }
        });

        const options = {
          key: orderRes.data.key_id,
          amount: orderRes.data.amount,
          currency: 'INR',
          name: 'Ahobilam.com',
          description: 'Archanai Service Booking',
          order_id: orderRes.data.order_id,
          handler: async function (response) {
            // Save booking
            await axios.post(`${API}/services/bookings`, {
              service_type: 'archanai',
              customer_details: bookingData,
              payment_id: response.razorpay_payment_id,
              payment_status: 'completed',
              amount: amount,
              booking_status: 'confirmed'
            });

            alert(language === 'en' 
              ? '🙏 Archanai booking confirmed! You will receive prasadam and a video recording of the puja.' 
              : '🙏 அர்ச்சனை பதிவு உறுதிப்படுத்தப்பட்டது! நீங்கள் பிரசாதம் மற்றும் பூஜையின் வீடியோ பதிவைப் பெறுவீர்கள்.');
            
            // Reset form
            setBookingData({
              name: '', email: '', phone: '', gotram: '', nakshatram: '',
              rashi: '', deity: '', temple: '', date: '', time: 'morning',
              specialRequests: '', participantNames: '', paymentMethod: 'razorpay'
            });
          },
          prefill: {
            name: bookingData.name,
            email: bookingData.email,
            contact: bookingData.phone
          },
          theme: { color: '#16a34a' }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      }
    } catch (error) {
      console.error('Booking error:', error);
      alert(language === 'en' ? 'Booking failed. Please try again.' : 'பதிவு தோல்வியடைந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-yellow-50 to-green-50 py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-green-800 mb-4">
            🙏 {language === 'en' ? 'Remote Archanai Service' : 'தொலை அர்ச்சனை சேவை'}
          </h1>
          <p className="text-xl text-gray-700">
            {language === 'en'
              ? 'Book personalized temple archana performed by qualified priests on your behalf'
              : 'உங்களின் சார்பாக தகுதியான குருமார்களால் நிகழ்த்தப்படும் தனிப்பயனாக்கப்பட்ட கோவில் அர்ச்சனையை பதிவு செய்யுங்கள்'}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Booking Form */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h2 className="text-3xl font-bold text-orange-600 mb-6">
                {language === 'en' ? 'Book Archanai' : 'அர்ச்சனை பதிவு செய்யுங்கள்'}
              </h2>

              <form onSubmit={handleBooking} className="space-y-6">
                {/* Contact Information */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Contact Information' : 'தொடர்பு தகவல்'}
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Your Name' : 'உங்கள் பெயர்'}
                      value={bookingData.name}
                      onChange={(e) => setBookingData({...bookingData, name: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="email"
                      placeholder={language === 'en' ? 'Email' : 'மின்னஞ்சல்'}
                      value={bookingData.email}
                      onChange={(e) => setBookingData({...bookingData, email: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>
                  <input
                    type="tel"
                    placeholder={language === 'en' ? 'Phone Number' : 'தொலைபேசி எண்'}
                    value={bookingData.phone}
                    onChange={(e) => setBookingData({...bookingData, phone: e.target.value})}
                    className="w-full mt-4 px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    required
                  />
                </div>

                {/* Astrological Details */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Astrological Details' : 'ஜோதிட விவரங்கள்'}
                  </h3>
                  <div className="grid md:grid-cols-3 gap-4">
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Gotram' : 'கோத்திரம்'}
                      value={bookingData.gotram}
                      onChange={(e) => setBookingData({...bookingData, gotram: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Nakshatram' : 'நட்சத்திரம்'}
                      value={bookingData.nakshatram}
                      onChange={(e) => setBookingData({...bookingData, nakshatram: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                    <input
                      type="text"
                      placeholder={language === 'en' ? 'Rashi' : 'ராசி'}
                      value={bookingData.rashi}
                      onChange={(e) => setBookingData({...bookingData, rashi: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>
                </div>

                {/* Deity Selection */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Select Deity' : 'தெய்வத்தை தேர்வு செய்யுங்கள்'}
                  </h3>
                  <select
                    value={bookingData.deity}
                    onChange={(e) => setBookingData({...bookingData, deity: e.target.value})}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    required
                  >
                    <option value="">{language === 'en' ? 'Choose Deity' : 'தெய்வத்தைத் தேர்ந்தெடுக்கவும்'}</option>
                    {deities.map(deity => (
                      <option key={deity.value} value={deity.value}>
                        {language === 'en' ? deity.label_en : deity.label_ta}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Temple Selection */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Select Temple' : 'கோவிலைத் தேர்வு செய்யுங்கள்'}
                  </h3>
                  <div className="space-y-3">
                    {temples.map(temple => (
                      <label key={temple.value} className="flex items-center justify-between p-4 border-2 rounded-lg cursor-pointer hover:bg-green-50 transition">
                        <div className="flex items-center">
                          <input
                            type="radio"
                            name="temple"
                            value={temple.value}
                            checked={bookingData.temple === temple.value}
                            onChange={(e) => setBookingData({...bookingData, temple: e.target.value})}
                            className="mr-3"
                            required
                          />
                          <span className="font-semibold">{language === 'en' ? temple.label_en : temple.label_ta}</span>
                        </div>
                        <span className="text-green-600 font-bold">₹{temple.price}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Date and Time */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Select Date & Time' : 'தேதி மற்றும் நேரத்தைத் தேர்வு செய்யுங்கள்'}
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <input
                      type="date"
                      value={bookingData.date}
                      onChange={(e) => setBookingData({...bookingData, date: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      min={new Date().toISOString().split('T')[0]}
                      required
                    />
                    <select
                      value={bookingData.time}
                      onChange={(e) => setBookingData({...bookingData, time: e.target.value})}
                      className="px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    >
                      {timeSlots.map(slot => (
                        <option key={slot.value} value={slot.value}>
                          {language === 'en' ? slot.label_en : slot.label_ta}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Additional Participants */}
                <div className="border-b pb-6">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    {language === 'en' ? 'Additional Names (Optional)' : 'கூடுதல் பெயர்கள் (விருப்பமானது)'}
                  </h3>
                  <textarea
                    placeholder={language === 'en' ? 'Enter additional family member names (one per line)' : 'கூடுதல் குடும்ப உறுப்பினர் பெயர்களை உள்ளிடவும் (ஒரு வரிக்கு ஒன்று)'}
                    value={bookingData.participantNames}
                    onChange={(e) => setBookingData({...bookingData, participantNames: e.target.value})}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    rows="3"
                  />
                </div>

                {/* Special Requests */}
                <div>
                  <label className="block text-lg font-semibold mb-2">
                    {language === 'en' ? 'Special Requests (Optional)' : 'சிறப்பு கோரிக்கைகள் (விருப்பமானது)'}
                  </label>
                  <textarea
                    value={bookingData.specialRequests}
                    onChange={(e) => setBookingData({...bookingData, specialRequests: e.target.value})}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500"
                    rows="3"
                    placeholder={language === 'en' ? 'Any specific prayers or wishes...' : 'ஏதேனும் குறிப்பிட்ட பிரார்த்தனைகள் அல்லது விருப்பங்கள்...'}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-orange-600 to-green-600 text-white py-4 rounded-lg hover:from-orange-700 hover:to-green-700 font-bold text-xl disabled:opacity-50 transition"
                >
                  {loading ? 'Processing...' : `${language === 'en' ? 'Book & Pay' : 'பதிவு செய்து செலுத்துங்கள்'} ₹${getSelectedPrice()}`}
                </button>
              </form>
            </div>
          </div>

          {/* Info Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-8">
              <h3 className="text-2xl font-bold text-green-800 mb-4">
                {language === 'en' ? 'What You Receive' : 'நீங்கள் பெறுவது'}
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">📹</span>
                  <span>{language === 'en' ? 'Video recording of the puja' : 'பூஜையின் வீடியோ பதிவு'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">🎁</span>
                  <span>{language === 'en' ? 'Prasadam delivered to your home' : 'பிரசாதம் உங்கள் வீட்டிற்கு வழங்கப்படும்'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">📜</span>
                  <span>{language === 'en' ? 'Certificate of Archanai' : 'அர்ச்சனை சான்றிதழ்'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">🙏</span>
                  <span>{language === 'en' ? 'Vedic chanting by expert priests' : 'நிபுணர் குருமார்களால் வேத பாராயணம்'}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">💫</span>
                  <span>{language === 'en' ? 'Same-day confirmation' : 'அதே நாள் உறுதிப்படுத்தல்'}</span>
                </li>
              </ul>

              <div className="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <p className="text-sm text-gray-700">
                  {language === 'en'
                    ? '✨ All pujas are performed following traditional Vaishnava agama sastras by qualified archaka pandits.'
                    : '✨ அனைத்து பூஜைகளும் தகுதியான அர்ச்சக பண்டிதர்களால் பாரம்பரிய வைஷ்ணவ ஆகம சாஸ்திரங்களைப் பின்பற்றி நிகழ்த்தப்படுகின்றன.'}
                </p>
              </div>

              <div className="mt-4 p-4 bg-orange-50 rounded-lg border border-orange-200">
                <p className="text-sm text-gray-700">
                  {language === 'en'
                    ? '📞 Questions? Contact us at +91-9876543210 or archanai@ahobilam.com'
                    : '📞 கேள்விகள்? +91-9876543210 அல்லது archanai@ahobilam.com என்ற முகவரியில் எங்களை தொடர்பு கொள்ளுங்கள்'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchanaiPage;
